export default function get_host(endpoint) {
  if (process.env.REACT_APP_BACKEND_PORT) {
    return `${process.env.REACT_APP_BACKEND_PROTO}://${process.env.REACT_APP_BACKEND_HOST}:${process.env.REACT_APP_BACKEND_PORT}${endpoint}`;
  }

  return `${process.env.REACT_APP_BACKEND_PROTO}://${process.env.REACT_APP_BACKEND_HOST}${endpoint}`;
}
